var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status",class:{
		new: _vm.status === _vm.statuses.NEW,
		'to-do': _vm.status === _vm.statuses.TO_DO,
		dismissed: _vm.status === _vm.statuses.DISMISSED,
		done: _vm.status === _vm.statuses.DONE,
		'done-for-you': _vm.status === _vm.statuses.DONE_FOR_YOU,
		scheduled: _vm.status === _vm.statuses.SCHEDULED,
		upcoming: _vm.status === _vm.statuses.UPCOMING,
	}},[_vm._v("\n\t"+_vm._s(_vm.status)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }